
const CONTENT_RESTRICTION_RULE = {
    PROFILE_MEDIAS_LIMIT : "PROFILE_MEDIAS_LIMIT",
    VIDEO_DURATION_LIMIT : "VIDEO_DURATION_LIMIT",
    VIEW_LAST_VISITORS: "VIEW_LAST_VISITORS",
    USER_BOOKMARKS_LIMIT: "USER_FAVORITES_LIMIT",
    USER_NOTIFICATIONS_LIMIT: "USER_NOTIFICATIONS_LIMIT",
    PROFIL_COLLECTION_MEDIAS_LIMIT: "PROFIL_COLLECTION_MEDIAS_LIMIT",
    PROFIL_FEED_PUBLICATIONS_LIMIT: "PROFIL_FEED_PUBLICATIONS_LIMIT",
    ADD_TO_CIRCLE: "ADD_TO_CIRCLE",
    MESSENGER: "MESSENGER",
    CREATE_PUBLICATION_MEDIA: "CREATE_PUBLICATION_MEDIA",
    MEMBERS_FILTER: "MEMBERS_FILTER",
    FOLLOW_MEMBER: 'FOLLOW_MEMBER',
    BOOKMARK_MEDIA: 'BOOKMARK_MEDIA',
    REPOST_CONTENT: 'REPOST_CONTENT',
    CREATE_POLL: 'CREATE_POLL',
    MEDIA_CONTRIBUTOR: 'MEDIA_CONTRIBUTOR',
    ENCOURAGE_GAME: 'ENCOURAGE_GAME',
    NATIVE_FULLSCREEN: 'NATIVE_FULLSCREEN',
    CREATE_EPHEMERAL_STORY: 'CREATE_EPHEMERAL_STORY',
    VIEW_EPHEMERAL_STORY: 'VIEW_EPHEMERAL_STORY',
    DARK_MODE: 'DARK_MODE',
    INCOGNITO: 'INCOGNITO',
    // Réaction premium (tout type autre que « J'aime ») — capability canReact.
    PREMIUM_REACTION: 'PREMIUM_REACTION',
    // Options de publication d'une story : durée de 48 h, visibilité réservée au cercle.
    STORY_LONG_DURATION: 'STORY_LONG_DURATION',
    STORY_CIRCLE: 'STORY_CIRCLE',
    // Statistiques : le détail (courbes, récap…) et la liste nominative des membres.
    VIEW_STATS: 'VIEW_STATS',
    VIEW_STATS_MEMBERS: 'VIEW_STATS_MEMBERS',
    // S'abonner : les boutons qui présentent les offres sans action derrière (menu, publicité du
    // fil, page de paiement, paramètres…).
    SUBSCRIBE: 'SUBSCRIBE',
}

export default CONTENT_RESTRICTION_RULE;